import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/Main'

/* MAIN CHILDRENDS */
import Dashboard from '@/components/Dashboard'
import Settings from '@/components/Settings'
import Events from '@/components/Events'
import Channels from '@/components/Channels';
import Instances from '@/components/Instances';
import Monitor from '@/components/Monitor';
import MonitorSideBar from '@/components/monitor/SideBar';
import SysMonitor from '@/components/SysMonitor';
import SysMonitorSideBar from '@/components/monitor/SysSideBar';
import Multiview from '@/components/Multiview';
import MultiviewEvents from '@/components/multiview/Events';
import Content from '@/components/Content';
import DashboardInstances from '@/components/dashboard/Instances'
import CloudRec from '@/components/CloudRec'
import DefaultSideBar from '@/components/DefaultSideBar'
import Devices from '@/components/Devices'
import Billing from '@/components/Billing'
import Developer from '@/components/Developer'
import DeveloperInstances from '@/components/developer/Instances'

import Productions from '@/components/Productions'

/* OTHER PAGES */
import Login from '@/components/Login'

Vue.use(Router)

import store from '@/store'


function require_access(account_types) {
  return (to, from, next) => {
    function proceed() {
      var account_type = Vue.prototype.$account_type();
      if (account_types.includes(account_type)) {
        next();
      } else {
        if (account_type == "cloudrec") {
          next("/cloudrec");
        } else {
          next(false);
        }
      }
    }
    if (typeof(store.state.account) == "undefined") {
      store.watch(
        (state) => state.account,
        (value) => {
          if (typeof(value) != "undefined") {
            proceed();
          }
        }
      );
    } else {
      proceed();
    }
  }
}

export default new Router({
  routes: [
    {
      path: '/',
      component: Main,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          redirect: "/dashboard"
        },
        {
          path: 'dashboard',
          components: {
            default: Dashboard,
            sidebar: DashboardInstances
          },
          children: Dashboard.routes,
          beforeEnter: require_access(["admin", "device_admin", "root", "developer", "group_admin", "user"])

        },
        {
          path: 'devices',
          component: Devices,
          children: Devices.routes,
          beforeEnter: require_access(["device_admin", "root", "developer"])
        },
        {
          path: 'developer',
          components: {
            default: Developer,
            sidebar: DeveloperInstances
          },
          children: Developer.routes,
          beforeEnter: require_access(["developer"])
        },
        {
          path: 'billing',
          component: Billing,
          children: Billing.routes,
          beforeEnter: require_access(["admin", "device_admin", "root", "developer"])
        },

        {
          path: 'settings',
          component: Settings,
          children: Settings.routes,
          beforeEnter: require_access(["admin", "device_admin", "root", "developer", "group_admin", "user"])

        },
        {
          path: 'events',
          component: Events,
          children: Events.routes,

          beforeEnter: require_access(["admin", "device_admin", "root", "developer", "group_admin", "user"])
        },
        {
          path: "channels",
          component: Channels,
          children: Channels.routes,
          beforeEnter: require_access(["admin", "device_admin", "root", "developer", "group_admin", "user"])
        },
        {
          path: "instances",
          components: {
            default: Instances,
            sidebar: DashboardInstances
          },
          children: Instances.routes,
          beforeEnter: require_access(["admin", "device_admin", "root", "developer"])

        },
        {
          path: "monitor",
          components: {
            default: Monitor,
            sidebar: MonitorSideBar
          },
          children: Monitor.routes,
          beforeEnter: require_access(["admin", "device_admin", "root", "developer", "group_admin", "user"])
        },
        {
          path: "sysmonitor",
          components: {
            default: SysMonitor,
            sidebar: SysMonitorSideBar
          },
          children: SysMonitor.routes,
          beforeEnter: require_access(["admin", "device_admin", "root", "developer"])
        },
        {
          path: "multiview",
          components: {
            default: Multiview,
            sidebar: MultiviewEvents
          },
          children: Multiview.routes,
          beforeEnter: require_access(["admin", "device_admin", "root", "developer", "group_admin", "user"])
        },
        {
          path: "content",
          components: {
            default: Content,
            sidebar: DefaultSideBar
          },
          children: Content.routes,
          beforeEnter: require_access(["admin", "device_admin", "root", "developer", "group_admin", "user"])
        },
        {
          path: "cloudrec",
          components: {
            default: CloudRec,
//            sidebar: DefaultSideBar
          },
          children: CloudRec.routes
        },
        {
          path: "productions",
          components: {
            default: Productions,
//            sidebar: DefaultSideBar
          },
          children: Productions.routes,
        },
        {
          path: "intercom",
          components: {
            default: Productions,
          },
          children: Productions.routes
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})
